import React from "react";
import {
    SiOpenai, SiGooglecloud, SiAmazons3, SiTrino, SiClickhouse, SiFastapi,
    SiReact, SiArgo, SiKubernetes, SiApachekafka, SiRedis, SiElasticsearch,
    SiTensorflow, SiGmail, SiNextdotjs, SiPython, SiMui, SiSocketdotio,
    SiGooglebigquery, SiVite, SiTerraform, SiAnsible, SiApachespark,
} from "react-icons/si";
import { FiCpu, FiLayers, FiDatabase, FiBarChart2, FiHardDrive, FiSmartphone, FiActivity, FiFileText } from "react-icons/fi";

// key -> { Icon, color } registry. Colors are brand-ish but tuned for a dark bg.
const ICONS = {
    openai: { Icon: SiOpenai, color: "#e6edf3" },
    ai: { Icon: FiCpu, color: "#56d4dd" },
    claude: { Icon: FiCpu, color: "#d97757" },
    gcp: { Icon: SiGooglecloud, color: "#4285F4" },
    s3: { Icon: SiAmazons3, color: "#7AB55C" },
    parquet: { Icon: FiHardDrive, color: "#8b949e" },
    trino: { Icon: SiTrino, color: "#DD79C2" },
    iceberg: { Icon: FiLayers, color: "#56d4dd" },
    clickhouse: { Icon: SiClickhouse, color: "#FAFF69" },
    fastapi: { Icon: SiFastapi, color: "#13B5A2" },
    react: { Icon: SiReact, color: "#61DAFB" },
    nextjs: { Icon: SiNextdotjs, color: "#e6edf3" },
    argo: { Icon: SiArgo, color: "#EF7B4D" },
    k8s: { Icon: SiKubernetes, color: "#5B8DEF" },
    kafka: { Icon: SiApachekafka, color: "#e6edf3" },
    redis: { Icon: SiRedis, color: "#FF6155" },
    elasticsearch: { Icon: SiElasticsearch, color: "#43C3B0" },
    tensorflow: { Icon: SiTensorflow, color: "#FF8F1C" },
    gmail: { Icon: SiGmail, color: "#EA4335" },
    python: { Icon: SiPython, color: "#6DA0D0" },
    mui: { Icon: SiMui, color: "#3F9CFF" },
    socketio: { Icon: SiSocketdotio, color: "#e6edf3" },
    bigquery: { Icon: SiGooglebigquery, color: "#4285F4" },
    vite: { Icon: SiVite, color: "#BD7BF8" },
    db: { Icon: FiDatabase, color: "#8b949e" },
    dashboard: { Icon: FiBarChart2, color: "#3fb950" },
    mobile: { Icon: FiSmartphone, color: "#56d4dd" },
    terraform: { Icon: SiTerraform, color: "#9B6BD8" },
    ansible: { Icon: SiAnsible, color: "#e6edf3" },
    spark: { Icon: SiApachespark, color: "#E2752F" },
    grafana: { Icon: FiActivity, color: "#F46800" },
    file: { Icon: FiFileText, color: "#8b949e" },
};

const Node = ({ label, icon, sub }) => {
    const entry = ICONS[icon] || ICONS.db;
    const { Icon, color } = entry;
    return (
        <div className="arch__node">
            <Icon className="arch__icon" style={{ color }}/>
            <span className="arch__node-label mono">{label}</span>
            {sub && <span className="arch__node-sub mono">{sub}</span>}
        </div>
    );
};

const ArchitectureDiagram = ({ zone, columns }) => {
    return (
        <div className="arch">
            <div className="arch__zone">
                {zone && <span className="arch__zone-label mono">☁ {zone}</span>}
                <div className="arch__flow">
                    {columns.map((col, ci) => (
                        <React.Fragment key={ci}>
                            <div className="arch__col">
                                {col.title && <span className="arch__col-title mono">{col.title}</span>}
                                <div className="arch__col-nodes">
                                    {col.nodes.map((n) => <Node key={n.label} {...n}/>)}
                                </div>
                            </div>
                            {ci < columns.length - 1 && (
                                <div className="arch__arrow" aria-hidden="true">
                                    <span className="arch__packet"></span>
                                </div>
                            )}
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ArchitectureDiagram;
